import { APP_JSON, BRANDING, USERNAME_TYPE } from '../../constants/common-enums';
import fetchReq from '../../helpers/fetch';
import StaticIdSingletonClass from '../../helpers/static-id';
import CONFIG from '../../settings';

const API = {
  /**
   * @param {string} apikey
   * @param {string} branding
   * @param {string} email
   * @param {string} sessionId
   * @param {string} thmProfileHint
   * @param {string} usernameType
   * @returns {object} response object
   */
  idLookup: ({
    apikey,
    branding = BRANDING.SRC,
    email,
    sessionId,
    thmProfileHint,
    usernameType = USERNAME_TYPE.EMAIL
  }) => {
    const dfpSessionId = sessionId || CONFIG.application.defaults.dfpSessionId;
    const requestPayload = {
      function: 'LOGIN@IDL',
      grant_type: 'idproof_promise',
      promises: [
        {
          data: email,
          data_kind: usernameType,
          ref: 1
        }
      ],
      response_type: ['token', 'id_token'],
      software_statement_claimset: {
        oauth2_version: '1.0',
        oidc_version: '1.0',
        software_id: branding,
        software_version: '21.03',
        tenancy_context: {
          product_code: 'VXO'
        },
        uebas: [
          {
            ueba_id: dfpSessionId,
            ueba_source: 'THREAT_METRIX'
          }
        ]
      }
    };
    const headers = {
      Accept: APP_JSON,
      Authorization: `Basic ${btoa(apikey)}`,
      'Content-Type': APP_JSON,
      dfpSessionId,
      ...(thmProfileHint && thmProfileHint !== 'null' && { 'x-via-hint': thmProfileHint })
    };
    const options = {
      body: requestPayload,
      headers,
      method: 'POST',
      url: CONFIG.application.api.token.idLookup(StaticIdSingletonClass.namespace)
    };

    return fetchReq(options);
  }
};

export default API;
